// extracted by mini-css-extract-plugin
module.exports = {"itemWrapper":"FolderAndPageList_itemWrapper__3fcMv","clickWrapper":"FolderAndPageList_clickWrapper__1NAId","selected":"FolderAndPageList_selected__nFYCQ"};